import { matchRoute } from './content/routes';
import type { HelpContent, HelpSection } from './content/types';

/**
 * The sections for the page the user is on: every section with a route matching `pathname`, the most
 * specific match first (`/shipments/:id` before `*`), then sections about `topic` (a dialog's subject),
 * then the guide's own order. Sections that only match through `*` come last.
 */
export function sectionsForPath(content: HelpContent, pathname: string, topic?: string): HelpSection[] {
  const position = new Map<string, number>();
  content.groups.flatMap((g) => g.sections).forEach((id, i) => position.set(id, i));
  const t = topic?.toLowerCase();
  const about = (s: HelpSection) =>
    t ? s.id.includes(t) || s.keywords.some((k) => k.toLowerCase().includes(t)) || s.title.toLowerCase().includes(t) : false;
  return content.sections
    .map((s) => ({ s, score: Math.max(-1, ...s.routes.map((r) => matchRoute(r, pathname) ?? -1)) }))
    .filter((x) => x.score >= 0)
    .sort(
      (a, b) =>
        Number(b.score > 0) - Number(a.score > 0) ||
        Number(about(b.s)) - Number(about(a.s)) ||
        b.score - a.score ||
        // Same match: a section about fewer pages is the more specific one.
        a.s.routes.length - b.s.routes.length ||
        (position.get(a.s.id) ?? 1e6) - (position.get(b.s.id) ?? 1e6),
    )
    .map((x) => x.s);
}
